import { get, post } from './https';

export interface AssignedUserCoupon {
  _id: string;
  userId: string;
  couponId: string;
  couponCode: string;
  coupon?: {
    _id: string;
    couponCode: string;
    name: string;
    discount: number;
    minValue: number;
    expiryDate: string | Date;
    isActive: boolean;
  } | null;
  assignedAmount: number;
  usedAmount: number;
  remainingAmount: number;
  expiresAt?: string | Date;
  status: 'ACTIVE' | 'USED' | 'EXPIRED' | 'REMOVED';
  note?: string;
  createdAt?: string;
  updatedAt?: string;
}

const getUserCoupons = async (userId: string, availableOnly = false) => {
  const response = await get(
    `/api/v1/admin/user/${userId}/coupons${availableOnly ? '?available=true' : ''}`,
  );
  return response.data as {
    status: boolean;
    data: AssignedUserCoupon[];
    count: number;
  };
};

const assignUserCoupon = async ({
  userId,
  couponId,
  assignedAmount,
  expiresAt,
  note,
}: {
  userId: string;
  couponId: string;
  assignedAmount: number;
  expiresAt?: string;
  note?: string;
}) => {
  const response = await post(`/api/v1/admin/user/${userId}/coupons/assign`, {
    couponId,
    assignedAmount,
    expiresAt,
    note,
  });
  return response.data as {
    status: boolean;
    message: string;
    data: AssignedUserCoupon;
  };
};

const removeUserCoupon = async (userCouponId: string) => {
  const response = await post(
    `/api/v1/admin/user-coupon/${userCouponId}/remove`,
  );
  return response.data as {
    status: boolean;
    message: string;
    data: AssignedUserCoupon;
  };
};

export { getUserCoupons, assignUserCoupon, removeUserCoupon };
